import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionsResponse } from "reduxStore/dataTypes";

interface AdminTransactionsState {
  adminTransactions: TransactionsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: AdminTransactionsState = {
  adminTransactions: null,
  loading: false,
  error: null,
};

const adminTransactionsSlice = createSlice({
  name: "adminTransactions",
  initialState,
  reducers: {
    adminTransactionsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    adminTransactionsSuccess(
      state,
      action: PayloadAction<TransactionsResponse>
    ) {
      state.loading = false;
      state.adminTransactions = action.payload;
    },
    adminTransactionsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  adminTransactionsRequest,
  adminTransactionsSuccess,
  adminTransactionsFailure,
} = adminTransactionsSlice.actions;
export default adminTransactionsSlice.reducer;
